import styled from 'styled-components';
import '../styles/FadeInFromBottom.css'
import FadeInFromBottom from '../shared/FadeInFromBottom';

const Wrapper = styled.div`
  margin: 0 0 32px 29px;
  p {
    font-size: 10px;
    line-height: 22px;
  }
`;

const Description = (props) => {
  const lines = props.text.split('\n');
  return (
    <Wrapper>
      {/* <FadeInFromBottom> */}
        {lines.map((line, index) => (
            <p key={index}>{line}</p>
        ))}
      {/* </FadeInFromBottom> */}
    </Wrapper>
    
  );
};
  
export default Description;
  